import { Param } from '../../../../../shared/types/param';

export const initialValues: Param = {
    name: '',
    valueSmart: '',
    active: true,
};
